const isNullOrEmpty = (str: any): boolean => {
    if (
        typeof str === "undefined" ||
        str == null ||
        str.toString().length === 0 ||
        str.toString().trim().length === 0
    ) {
        return true;
    } else {
        return false;
    }
};

const getUserLang = (pathname: string): string => {
    var userLang: string = navigator.language || (navigator as any).userLanguage;
    var lang = "en";
    if (!isNullOrEmpty(userLang) && userLang.indexOf("de") > -1) {
        lang = "de";
    } else if (!isNullOrEmpty(userLang) && userLang.indexOf("pl") > -1) {
        lang = "pl";
    } else if (!isNullOrEmpty(userLang) && userLang.indexOf("es") > -1 && pathname.indexOf("bkcapp") !== -1) {
        lang = "es";
    } else if (!isNullOrEmpty(userLang) && userLang.indexOf("fr") > -1 && pathname.indexOf("bkcapp") !== -1) {
        lang = "fr";
    } else if (!isNullOrEmpty(userLang) && userLang.indexOf("ms") > -1 && pathname.indexOf("bkcapp") !== -1) {
        lang = "ms";
    }
    return lang;
}

export {
    isNullOrEmpty, getUserLang
};
